module.exports = __webpack_public_path__ + "img/register.894ae0fc.svg";